import React from "react";
import image from "../../../Asset/testimonial/image.png";
import imagee from "../../../Asset/testimonial/imagee.png";

const Cards = ({ item }) => {
  return (
    <div className="w-full p-4 bg-white rounded-3xl">
      <div className="flex justify-between my-5">
        <div className="w-14 h-10">
          <img src={image} alt="img" className="w-full h-full object-cover" />
        </div>
        <div
          className="w-14 h-14 object-cover3
            "
        >
          <img src={imagee} alt="" />
        </div>
      </div>
      <div className="sm:mt-10 mt-5">
        <p className="text-wrap">
          Pure, fresh, and trustworthy! Their organic products have transformed
          our meals. Highly recommend!
        </p>
      </div>
      <div className="p-4 bg-Background4 flex gap-5 items-center mt-6 lg:mt-20 xl:mt-30 rounded-lg">
        <div className="w-16 h-16 bg-white rounded-full">
          <img
            src={item?.image}
            className="w-full h-full rounded-full object-cover cursor-pointer"
            alt="ggg"
          />
        </div>
        <span className="font-semibold text-xl text-textColor title1">
          Srishita Kumar
        </span>
      </div>
    </div>
  );
};

export default Cards;
